import searchAtomPair, { SearchParams } from 'atoms/search-atom';
import type { PackageLibraryResult, PackageLibraryAggregations } from './types';

export interface PackageLibraryParams extends SearchParams {
  interestTypes?: string[];
  containsInventoryAssets?: boolean | null;
  createdAtStart?: string;
  createdAtEnd?: string;
  updatedAtStart?: string;
  updatedAtEnd?: string;
}

export const createPackageLibrarySearchAtom = () =>
  searchAtomPair<
    PackageLibraryResult,
    PackageLibraryParams,
    undefined,
    PackageLibraryAggregations
  >({ href: '/queries/packages' });
